import { Field } from '@egw/components'

interface FieldType {
  className?: string
  onEdit: () => void
  rightSide?: string | React.ReactNode
  testId: string
  value: string
  isPII?: boolean
}

interface ConfirmationSectionProps {
  title: string
  fields: FieldType[]
}

export const ConfirmationSection = ({ title = 'Title', fields = [] }: ConfirmationSectionProps) => {
  return (
    <div className="mb-lg">
      <header className="typo-primary-md-semibold mb-xs">{title}</header>
      {fields.map((e) => {
        return (
          <Field
            valueClassName="text-text-meta typo-primary-base-regular"
            value={e.value}
            rightValue={e.rightSide}
            className="border-b py-md last:border-0"
            testId={e.testId}
            onEdit={e.onEdit}
            key={e.testId}
            isPII={e.isPII}
          />
        )
      })}
    </div>
  )
}
